"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OebbI18n = /** @class */ (function () {
    function OebbI18n(lang, strings) {
        if (lang === void 0) { lang = 'de'; }
        if (strings === void 0) { strings = []; }
        this.set(lang, strings);
    }
    OebbI18n.getInstance = function () {
        if (!OebbI18n.instance)
            OebbI18n.instance = new OebbI18n();
        return OebbI18n.instance;
    };
    OebbI18n.prototype.setLang = function (lang) {
        this.lang = lang;
    };
    OebbI18n.prototype.getLang = function () {
        return this.lang;
    };
    OebbI18n.prototype.setStrings = function (strings) {
        this.strings = strings;
    };
    OebbI18n.prototype.getStrings = function () {
        return this.strings;
    };
    OebbI18n.prototype.setPrefix = function (prefix) {
        this.prefix = prefix;
    };
    OebbI18n.prototype.getPrefix = function () {
        return this.prefix;
    };
    OebbI18n.prototype.set = function (lang, strings) {
        this.lang = lang;
        this.strings = strings;
    };
    OebbI18n.prototype.add = function (strings) {
        this.strings = this.strings.concat(strings);
    };
    OebbI18n.prototype.get = function (key, fallback, values, fallbackLang, count) {
        if (this.prefix)
            key = this.prefix + key;
        if (count != null && count < 2)
            key = key + "#" + count;
        var output = (!fallback && fallback !== null) ? key : fallback;
        if (output === null)
            output = '';
        var result = this.strings.filter(function (element) {
            return element.key == key;
        });
        if (result.length > 0) {
            if (result[0][this.lang]) {
                output = result[0][this.lang];
            }
            else if (fallbackLang && result[0][fallbackLang]) {
                output = result[0][fallbackLang];
            }
        }
        if (values instanceof Array) {
            if (values && values.length) {
                values.forEach(function (value, i) {
                    output = output.replace("{" + i + "}", value);
                });
            }
        }
        else if (values) {
            output = output.replace("{0}", values);
        }
        return output;
    };
    return OebbI18n;
}());
exports.OebbI18n = OebbI18n;
function createInstance(lang, strings) {
    if (lang === void 0) { lang = 'de'; }
    if (strings === void 0) { strings = []; }
    return new OebbI18n(lang, strings);
}
exports.createInstance = createInstance;
function findLocale(element) {
    var closestElement = element.closest('[lang]');
    if (closestElement)
        return closestElement.lang;
    if (document.body.lang)
        return document.body.lang;
    if (document.documentElement.lang)
        return document.documentElement.lang;
    return 'de';
}
exports.findLocale = findLocale;
var i18n = OebbI18n.getInstance();
exports.i18n = i18n;
